import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import NosotrosPage from "./pages/NosotrosPage";


// ❗IMPORTA EL CSS AQUÍ
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/nosotros" element={<NosotrosPage />} />
      
    </Routes>
  </BrowserRouter>
);
